module.exports = __webpack_public_path__ + "static/media/green_tick.60ea3402.svg";